import { memoize } from "decko";
import EnvironmentTypes from "const/EnvironmentTypes";
import NodeEnvironmentTypes from "const/NodeEnvironmentTypes";

export default class Environment {
  @memoize
  static getProcessEnvVars() {
    return Object.fromEntries(
      Object.entries(process.env).map(([key, value]) => {
        return [key.indexOf("REACT_APP") === 0 ? key.split("REACT_APP_").pop() : key, value];
      })
    );
  }

  @memoize
  static checkIsDefaultAppDomain() {
    return window.location.origin === Environment.getProcessEnvVars().DEFAULT_APP_URL;
  }

  @memoize
  static checkIsVercelDomain() {
    return window.location.origin.endsWith("vercel.app");
  }

  @memoize
  static checkIsLocalhost() {
    return window.location.hostname === "localhost";
  }

  @memoize
  static checkIsDevMode() {
    return Environment.getProcessEnvVars().NODE_ENV === NodeEnvironmentTypes.DEVELOPMENT;
  }

  @memoize
  static checkIsStagingEnv() {
    return Environment.getProcessEnvVars().ENV_TYPE === EnvironmentTypes.STAGING;
  }

  @memoize
  static checkIsProductionEnv() {
    return Environment.getProcessEnvVars().ENV_TYPE === EnvironmentTypes.PRODUCTION;
  }
}
